import { breakpoints, Button } from "@brightagency/headstart-common";
import React from "react";
import styled from "styled-components";
import { useGlobalAcf } from "../../../services/app-state";
import { useAssessmentState } from "../../../services/assessment-state";
import { ImmediateDangerNotifcation } from "./ImmediateDangerNotification";
import { TextButtonGroup } from "./shared/TextButton";
import { SectionTitle } from "./shared/styled";

const Image = styled.img`
    max-width: 250px;
    width: 100%;
    padding: 24px 0;
    margin-top: -16px;

    ${breakpoints.medium} {
        max-width: 420px;
        padding: 0 0 32px 0;
        margin-top: -32px;
    }
`;

export const Content = styled.div`
    margin: 24px 0;

    ${breakpoints.medium} {
        margin: 32px 0;
    }
`;

export const Intro: React.FC = () => {
    const { goNext } = useAssessmentState();
    const [isNotificationVisible, setIsNotificationVisible] = React.useState(false);

    const [
        {
            global_elements: { not_sure_where_to_begin },
        },
    ] = useGlobalAcf();
    const IntroImage = not_sure_where_to_begin.image.url;

    return (
        <>
            <Image src={IntroImage} alt="" />
            <SectionTitle>Not sure where to begin?</SectionTitle>
            <Content>
                <p>
                    By answering a few questions we can help you find local, phone and digital mental health services based on your eligibility. No personal contact information is required and your responses and results are only viewable by you.
                </p>
            </Content>
            <TextButtonGroup>
                <Button
                    maxWidth={-1}
                    appearance="secondary"
                    onClick={() => {
                        setIsNotificationVisible(true);
                    }}
                >
                    Get started
                </Button>
            </TextButtonGroup>
            <ImmediateDangerNotifcation
                isVisible={isNotificationVisible}
                onClose={() => {
                    setIsNotificationVisible(false);
                }}
                onContinue={() => {
                    setIsNotificationVisible(false);
                    goNext();
                }}
            />
        </>
    );
};
